// Decode HTML entities (handles once/twice-escaped HTML)
function decodeHTMLEntities(str) {
  if (!str) return "";
  if (typeof document === "undefined") return str;
  const decodeOnce = (s) => {
    const el = document.createElement("textarea");
    el.innerHTML = s;
    return el.value;
  };
  let out = decodeOnce(str);
  if (/[&](?:amp|lt|gt|quot|#39|#x27);/i.test(out)) out = decodeOnce(out);
  return out;
}

const TextContent = ({ content }) => {
  const decoded = decodeHTMLEntities(content);
  return (
    <div className="w-full overflow-y-auto bg-white rounded-lg p-6 shadow-md">
      <div
        className="prose max-w-none prose-headings:font-bold prose-headings:text-black prose-a:text-black 
          prose-h1:text-2xl prose-h1:mt-6 prose-h1:mb-4
          prose-h2:text-xl prose-h2:mt-5 prose-h2:mb-
          prose-h3:text-lg prose-h3:mt-4 prose-h3:mb-2
          prose-p:my-2 prose-p:leading-relaxed
          prose-ul:list-disc prose-ul:pl-5 prose-ol:list-decimal prose-ol:pl-5
          prose-li:my-1
          prose-img:max-w-full prose-img:h-auto prose-img:mx-auto
          prose-table:border-collapse prose-table:w-full
          prose-pre:bg-gray-100 prose-pre:p-4 prose-pre:rounded-md prose-pre:overflow-x-auto
          notes-container animate-fade-in"
        dangerouslySetInnerHTML={{ __html: decoded }}
      />
    </div>
  );
};

export default TextContent;
